import { Component, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-user-link',
  imports: [RouterLink, NgTemplateOutlet],
  template: `
    <ng-template #content><ng-content /></ng-template>
    @if (userId) {
      <a
        class="user-link"
        data-testid="user-profile-link"
        [routerLink]="['/profile', userId]"
        [attr.aria-label]="decorative ? null : ariaLabel || null"
        [attr.aria-hidden]="decorative ? 'true' : null"
        [attr.tabindex]="decorative ? -1 : null"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="content" />
    }
  `,
  styles: `
    :host {
      display: inline;
    }
    .user-link {
      color: inherit;
      text-decoration: none;
      cursor: pointer;
    }
    .user-link:hover {
      text-decoration: underline;
    }
    .user-link:focus-visible {
      outline: 2px solid var(--handle-blue, #1e468b);
      outline-offset: 2px;
      border-radius: 4px;
    }
  `,
})
export class UserLink {
  /** Id of the user whose profile to open. No link is rendered when absent. */
  @Input() userId: number | null | undefined = null;

  /** Accessible name, e.g. "View Jordan Lee's profile". Optional for text links. */
  @Input() ariaLabel = '';

  /** Hide from keyboard/assistive tech when a sibling link goes to the same place. */
  @Input() decorative = false;
}
